import { create } from "zustand";

export const useActaDetalleStore = create((set, get) => ({
  actaDetalle: null,
  acta: null,
  archivos: null,
  alertas: null,
  alertasBloqueo: null,
  alertasNoBloqueo: null,
  recibo: null,

  coleccionActasDetalle: [],

  setAllActaDetalle: (acta) => {
    set((state) => {
      const existeActa = state.coleccionActasDetalle.some((a) => a.acta?.id === acta.acta.id);

      const nuevaColeccionActasDetalle = existeActa
        ? state.coleccionActasDetalle
        : [...state.coleccionActasDetalle, acta];
      return {
        actaDetalle: acta,
        acta: acta.acta,
        archivos: acta.archivos,
        alertas: acta.acta.alertas,
        alertasBloqueo: acta.acta?.alertas?.filter((alerta) => alerta.bloqueo == 1),
        alertasNoBloqueo: acta.acta?.alertas?.filter((alerta) => alerta.bloqueo == 0),
        coleccionActasDetalle: nuevaColeccionActasDetalle,
      };
    });
  },

  setColeccionActasDetalle: (coleccion) => {
    set({ coleccionActasDetalle: coleccion });
  },

  setActa: (acta) => {
    set({ acta: acta });
  },

  setArchivosActas: (actas) => {
    set((state) => {
      return {
        archivos: {
          ...state?.archivos,
          actas: actas,
        },
      };
    });
  },

  setArchivos: (archivos) => {
    set((state) => ({
      actaDetalle: { ...state.actaDetalle, archivos: archivos },
    }));
  },

  cleanStore: () => {
    set({
      actaDetalle: null,
      acta: null,
      archivos: null,
      alertas: null,
      alertasBloqueo: null,
      alertasNoBloqueo: null,

      coleccionActasDetalle: [],
    });
  },

  setRecibo: (recibo) => {
    set({
      recibo: recibo,
    });
  },

  setAvisoVisita: (avisoVisita) => {
    set((state) => {
      return {
        archivos: {
          ...state.archivos, 
          aviso: {
            type: avisoVisita.type, 
            file: avisoVisita.file, 
          },
        },
      };
    });
  },
}));
